import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/**
 * Copyright IBM Corp. 2016, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */


import React, { useRef } from 'react';
import ArrowRight20 from '@carbon/icons-react/es/arrow--right/20';
import { Card } from '../Card';
import { CTA } from '../CTA';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings';
import settings from 'carbon-components/es/globals/js/settings';
var stablePrefix = ddsSettings.stablePrefix;
var prefix = settings.prefix;
/**
 * CardGroup component
 */

var CardGroup = function CardGroup(_ref) {
  var cards = _ref.cards,
      cta = _ref.cta;
  var containerRef = useRef();
  return _renderCards(cards, containerRef, cta);
};
/**
 * Renders the cards based on the CardGroup entries.
 *
 * @param {Array} cards objects array
 * @param {object} containerRef ref of elements
 * @param {object} cta object
 * @returns {*} CardGroup JSX objects
 */


var _renderCards = function _renderCards(cards, containerRef, cta) {
  return React.createElement("div", {
    "data-autoid": "".concat(stablePrefix, "--card-group"),
    className: "".concat(prefix, "--card-group__cards__row ").concat(prefix, "--row--condensed"),
    ref: containerRef
  }, cards.map(function (card, index) {
    return React.createElement("div", {
      key: index,
      className: "".concat(prefix, "--card-group__cards__col"),
      role: "region",
      "aria-label": card.heading
    }, React.createElement(CTA, {
      style: "card",
      key: index,
      customClassName: "".concat(prefix, "--card-group__card"),
      image: card.image,
      media: card.media,
      heading: card.heading,
      eyebrow: card.eyebrow,
      copy: card.copy,
      pictogram: card.pictogram,
      cta: _objectSpread({}, card.cta, {
        icon: {
          src: ArrowRight20
        }
      }),
      type: card.media ? 'video' : card.type ? card.type : 'local'
    }));
  }), cta && React.createElement("div", {
    className: "".concat(prefix, "--card-group__cards__col")
  }, React.createElement(Card, {
    inverse: true,
    heading: cta.heading,
    cta: {
      href: cta.cta.href,
      icon: {
        src: ArrowRight20
      }
    }
  })));
};

export default CardGroup;